import { Link } from 'react-router-dom';
import { collections } from '@/mocks/collections';
import { formatViews } from '@/components/feature/CollectionCard';

export default function LatestUpdates() {
  const latest = [...collections]
    .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
    .slice(0, 5);

  const ranking = [...collections].sort((a, b) => b.views - a.views).slice(0, 6);

  return (
    <section className="w-full px-4 md:px-10 py-14 md:py-20 bg-background-100">
      <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
        <div className="lg:col-span-2">
          <div className="flex items-end justify-between gap-4 mb-6">
            <div>
              <span className="text-xs md:text-sm label-font text-secondary-600 tracking-[0.2em]">
                UPDATES
              </span>
              <h2 className="mt-2 font-heading font-bold text-2xl md:text-3xl text-foreground-950">
                最近更新的合集
              </h2>
            </div>
            <Link
              to="/collections?sort=updated"
              className="text-sm label-font text-primary-600 hover:text-primary-700 whitespace-nowrap"
            >
              更多更新
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <ol className="relative border-l border-background-300 ml-2">
            {latest.map((item) => (
              <li key={item.id} className="relative pl-6 pb-7 last:pb-0">
                <span className="absolute -left-[7px] top-1 w-3 h-3 rounded-full bg-primary-500 ring-4 ring-background-100"></span>
                <div className="flex flex-wrap items-center gap-2 text-xs label-font text-foreground-500">
                  <time dateTime={item.updatedAt}>{item.updatedAt}</time>
                  <span className="px-2 py-0.5 rounded-md bg-secondary-100 text-secondary-800">
                    {item.category}
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {formatViews(item.views)}
                  </span>
                </div>
                <h3 className="mt-2 font-heading font-bold text-base md:text-lg text-foreground-950">
                  <Link to={`/collections/${item.id}`} className="hover:text-primary-600 transition-colors">
                    新增节点 · {item.title}
                  </Link>
                </h3>
                <p className="mt-1 text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.entries[item.entries.length - 1].title}：{item.entries[item.entries.length - 1].text}
                </p>
              </li>
            ))}
          </ol>
        </div>

        <aside className="lg:col-span-1">
          <div className="rounded-lg bg-background-50 border border-background-200 p-5 md:p-6">
            <div className="flex items-center gap-2 mb-5">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-primary-100 text-primary-700">
                <i className="ri-fire-line text-lg"></i>
              </span>
              <h2 className="font-heading font-bold text-lg text-foreground-950">本周热度榜</h2>
            </div>
            <ol className="space-y-4">
              {ranking.map((item, index) => (
                <li key={item.id} className="flex gap-3">
                  <span
                    className={`shrink-0 w-6 h-6 flex items-center justify-center rounded-md text-xs font-bold label-font ${
                      index < 3
                        ? 'bg-primary-500 text-background-50'
                        : 'bg-background-200 text-foreground-600'
                    }`}
                  >
                    {index + 1}
                  </span>
                  <div className="min-w-0">
                    <Link
                      to={`/collections/${item.id}`}
                      className="block text-sm font-medium text-foreground-900 hover:text-primary-600 transition-colors truncate"
                      title={item.title}
                    >
                      {item.title}
                    </Link>
                    <span className="text-xs text-foreground-500 label-font flex items-center gap-1">
                      <i className="ri-eye-line"></i>
                      {formatViews(item.views)} 次阅读
                    </span>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <div className="mt-5 rounded-lg bg-accent-500 text-accent-950 p-5 md:p-6">
            <h3 className="font-heading font-bold text-lg">想看哪一类的瓜？</h3>
            <p className="mt-2 text-sm text-accent-950/80 leading-relaxed">
              告诉我们你关注的事件方向，我们会优先把它整理成完整的时间线专题。
            </p>
            <Link
              to="/about#contact"
              className="mt-4 inline-flex items-center gap-2 px-4 py-2 rounded-md bg-accent-950 text-accent-50 text-sm label-font hover:bg-foreground-950 transition-colors whitespace-nowrap"
            >
              <i className="ri-lightbulb-line"></i>
              提交选题建议
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}